module.exports = __webpack_public_path__ + "img/fz.c648881d.png";